import PropTypes from 'prop-types';
import { useState } from 'react';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Button } from 'foundations-components/transitional/components/Button';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { Form } from 'foundations-components/transitional/components/Form';
import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18n = key => `knowledgeContentUI.templateEditor.confirmDeletionModal.${key}`;
function ConfirmDeletionModal({
  onClose,
  onDeleteConfirm
}) {
  const [neverShowDeletionModal, setNeverShowDeletionModal] = useState(false);
  const toggleNeverShowAgain = ({
    target: {
      checked
    }
  }) => setNeverShowDeletionModal(checked);
  return /*#__PURE__*/_jsx(Modal, {
    centered: true,
    use: "conversational",
    width: 600,
    children: /*#__PURE__*/_jsxs(Form, {
      onSubmit: () => {
        onDeleteConfirm(neverShowDeletionModal);
      },
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        className: "text-start m-bottom-3",
        children: /*#__PURE__*/_jsxs(TFlex, {
          justify: "start",
          children: [/*#__PURE__*/_jsx(H3, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18n('header')
            })
          }), /*#__PURE__*/_jsx(DialogCloseButton, {
            onClick: onClose
          })]
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        className: "text-start",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18n('bodyText')
        }), /*#__PURE__*/_jsx(Checkbox, {
          defaultChecked: false,
          onClick: toggleNeverShowAgain,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18n('showModalAgain')
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        align: "left",
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18n('delete')
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18n('cancel')
          })
        })]
      })]
    })
  });
}
ConfirmDeletionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDeleteConfirm: PropTypes.func.isRequired
};
export default ConfirmDeletionModal;